const TIME_SLICE_EPS = 1e-9;

/**
 * 校验 stableFragments，统一为 `{ startTime, endTime }`。
 * @param {unknown} raw
 * @returns {{ startTime: number, endTime: number }[]}
 */
export function coerceStableFragments(raw) {
    if (!Array.isArray(raw) || raw.length === 0) {
        return [];
    }
    /** @type {{ startTime: number, endTime: number }[]} */
    const out = [];
    for (const f of raw) {
        const st = Number(f?.startTime ?? f?.start_time);
        const en = Number(f?.endTime ?? f?.end_time);
        if (Number.isFinite(st) && Number.isFinite(en) && en > st + TIME_SLICE_EPS) {
            out.push({ startTime: st, endTime: en });
        }
    }
    out.sort((a, b) => a.startTime - b.startTime);
    return out;
}

/**
 * 将片段裁剪到检测区间并过滤无效段。
 * @param {{ startTime: number, endTime: number }[]} fragments
 * @param {number} timeMin
 * @param {number} timeMax
 */
export function clipFragmentsToRange(fragments, timeMin, timeMax) {
    return fragments
        .filter(f => f.endTime > timeMin && f.startTime < timeMax)
        .map(f => ({
            startTime: Math.max(f.startTime, timeMin),
            endTime: Math.min(f.endTime, timeMax),
        }))
        .filter(f => f.endTime > f.startTime + TIME_SLICE_EPS);
}
